import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { MsalService } from '../msal';

@Injectable({
  providedIn: 'root'
})
export class AudioService {
  private urlbase = environment.urlAudioApi;
  private audioscope = environment.scopeAudioApi;

  constructor(private authService: MsalService) { }

  async getAudioMeeting(drEventId: number, drRecId: number, lang: string): Promise<string> {
    const requestObj = {
      scopes: [this.audioscope]
    };

    console.log(requestObj);

    const response = await this.authService.acquireTokenSilent(requestObj).toPromise();

    console.log(response);
    return `${this.urlbase}${drEventId}_${drRecId}_${lang}.wav?access_token=${response.accessToken}`;
  }
}
